import React from "react";
import MyIcon from "./MyIcon";
import HelpButton from "../HelpContent/HelpButton";

export default function Subheading({
  Icon,
  heading,
  subheading,
  iconWidth = 30,
  helpKey = "",
}) {
  const generatedHelpKey = heading
    .toString()
    .toLowerCase()
    .replace(/\//g, "")
    .replace(/\s+/g, "-");

  return (
    <div className="mb-3 d-flex align-items-center">
      <MyIcon Icon={Icon} width={iconWidth} />
      <div className="mx-3">
        <h5 className="m-0 fw-bold">
          {heading}{" "}
          <span onClick={(e) => e.stopPropagation()}>
            <HelpButton helpKey={helpKey || generatedHelpKey} />
          </span>
        </h5>
        <div className="small text-secondary">{subheading}</div>
      </div>
    </div>
  );
}
